import { useState, useEffect } from "react";
import InputField from "../UI/InputField";
import Button from "../UI/Button";
import { hasDifferentLayout, isFes } from "../../utils/diffentLayoutCheck";
const ArchiveSearchField = (props) => {
  const [inputValue, setInputValue] = useState({ searchText: "" });
  const searchPlaceholder = process.env.REACT_APP_SEARCH_PLACHEHOLDER || "SEARCH IN THE STACKS...";

  const { searchText } = inputValue;
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // this useEffect will send the input to the parent component
  // only 500 ms after the last input was inserted, to avoid
  // backend overloads
  useEffect(() => {
    const identifier = setTimeout(() => {
      props.setField(inputValue.searchText);
    }, 500);
    return () => {
      clearTimeout(identifier);
    };
    // eslint-disable-next-line
  }, [inputValue]);
  const btnHandler = () => {
    props.buttonHandler();
  };
  const resetHandler = () => {
    props.resetHandler();
  };
  const filtersHandler = () => {
    props.showFiltersMobile()
  }
  return (
    <div
      className={`fixed ${
        hasDifferentLayout() ? isFes() ? "top-[80px]": "top-[70px]" : "top-0"
      } w-full h-[100px] lg:h-[70px] border-[0.5px] border-black border-solid flex flex-col lg:flex-row items-center px-5 lg:pl-4 lg:pr-10 justify-between max-lg:py-2.5`}
    >
      {props.hasAdvanceQuery ? (
        <div>
          Advanced search terms:
          {props.queries.map((el, i) => (
            <span key={"adv-t" + i}>
              {JSON.stringify(el.query)}
              {i < props.queries.length - 1 ? "," : null}
            </span>
          ))}
        </div>
      ) : (
        <InputField
          className="flex growth"
          type="text"
          value={searchText}
          placeholder={searchPlaceholder}
          name="searchText"
          onChange={handleChange}
          noPadding={true}
        />
      )}
      <div className="flex flex-row max-lg:w-full">
        {!props.hasAdvanceQuery ? (
          <div className="lg:hidden mr-2.5">
            <Button label={"Filters"} action={filtersHandler} />
          </div>
        ) : null}
        {props.hasAdvanceQuery ? (
          <div className="mx-5">
            <Button label={"clear all"} isDanger={true} action={resetHandler} />
          </div>
        ) : null}
        {props.projectWithAdvancedSearch && (
          <Button
            label={
              props.queries.length > 1
                ? "Edit Advanced search"
                : "Advanced search"
            }
            action={btnHandler}
          />
        )}
      </div>
    </div>
  );
};
export default ArchiveSearchField;
